var _Defs, _Use, _Use2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Defs, LinearGradient, Stop, Symbol as _Symbol, Path, Use } from "react-native-svg";
function SvgSnowy(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512"
  }, props), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "snowy_svg__b",
    x1: 99.45,
    y1: 30.68,
    x2: 232.64,
    y2: 261.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.45,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#deeafb"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "snowy_svg__a",
    x1: 11.38,
    y1: 5.93,
    x2: 32.82,
    y2: 43.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0,
    stopColor: "#86c3db"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.45,
    stopColor: "#86c3db"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#5eafcf"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "snowy_svg__c",
    x1: 67.38,
    y1: 95.93,
    x2: 88.82,
    y2: 133.07,
    xlinkHref: "#snowy_svg__a"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0,
    stopColor: "#86c3db"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.45,
    stopColor: "#86c3db"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#5eafcf"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "snowy_svg__d",
    x1: 123.38,
    y1: 45.93,
    x2: 144.82,
    y2: 83.07,
    xlinkHref: "#snowy_svg__a"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0,
    stopColor: "#86c3db"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.45,
    stopColor: "#86c3db"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#5eafcf"
  })), /*#__PURE__*/React.createElement(_Symbol, {
    id: "snowy_svg__e",
    viewBox: "0 0 350 222"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M291 107c-.85 0-1.68.09-2.53.13A83.9 83.9 0 00135.6 42.92 55.91 55.91 0 0051 91a56.56 56.56 0 00.8 9.08A60 60 0 0063 219c1.35 0 2.67-.11 4-.2v.2h224a56 56 0 000-112z",
    stroke: "#959aa2",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    fill: "url(#snowy_svg__b)"
  })), /*#__PURE__*/React.createElement(_Symbol, {
    id: "snowy_svg__f",
    viewBox: "0 0 156.2 139"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M41.67 31l-5.78-3.3a13.74 13.74 0 000-6.47L41.67 18a4 4 0 001.49-5.46A4.08 4.08 0 0037.62 11l-5.79 3.3a13.61 13.61 0 00-2.64-2 13.84 13.84 0 00-3-1.28V4.5a4.05 4.05 0 00-8.1 0v6.6a14.25 14.25 0 00-5.69 3.23L6.58 11A4.08 4.08 0 001 12.5 4 4 0 002.53 18l5.78 3.3a13.74 13.74 0 000 6.47L2.53 31A4 4 0 001 36.5a4.08 4.08 0 003.52 2 4 4 0 002-.54l5.79-3.3a13.61 13.61 0 002.64 2 13.8 13.8 0 003 1.27v6.57a4.05 4.05 0 008.1 0v-6.61a14.22 14.22 0 005.68-3.23L37.62 38a4 4 0 002 .54 4.08 4.08 0 003.52-2A4 4 0 0041.67 31zm-22.61-1.3a6 6 0 01-2.22-8.2 6.1 6.1 0 015.27-3 6.16 6.16 0 013 .8 6 6 0 012.22 8.2 6.12 6.12 0 01-8.27 2.2z",
    stroke: "#86c3db",
    strokeMiterlimit: 10,
    fill: "url(#snowy_svg__a)"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M97.67 121l-5.78-3.3a13.74 13.74 0 000-6.47l5.78-3.23a4 4 0 001.49-5.46 4.08 4.08 0 00-5.54-1.54l-5.79 3.3a13.61 13.61 0 00-2.64-2 13.84 13.84 0 00-3-1.28V94.5a4.05 4.05 0 00-8.1 0v6.6a14.25 14.25 0 00-5.69 3.23L62.58 101a4.08 4.08 0 00-5.58 1.5 4 4 0 001.53 5.5l5.78 3.3a13.74 13.74 0 000 6.47L58.53 121a4 4 0 00-1.53 5.5 4.08 4.08 0 003.52 2 4 4 0 002-.54l5.79-3.3a13.61 13.61 0 002.64 2 13.8 13.8 0 003 1.27v6.61a4.05 4.05 0 008.1 0v-6.61a14.22 14.22 0 005.68-3.23l5.79 3.3a4 4 0 002 .54 4.08 4.08 0 003.52-2 4 4 0 00-1.37-5.54zm-22.61-1.3a6 6 0 01-2.22-8.2 6.1 6.1 0 015.27-3 6.16 6.16 0 013 .8 6 6 0 012.22 8.2 6.12 6.12 0 01-8.27 2.2z",
    stroke: "#86c3db",
    strokeMiterlimit: 10,
    fill: "url(#snowy_svg__c)"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M153.67 71l-5.78-3.3a13.74 13.74 0 000-6.47l5.78-3.23a4 4 0 001.49-5.46 4.08 4.08 0 00-5.54-1.54l-5.79 3.3a13.61 13.61 0 00-2.64-2 13.84 13.84 0 00-3-1.28V44.5a4.05 4.05 0 00-8.1 0v6.6a14.25 14.25 0 00-5.69 3.23L118.58 51a4.08 4.08 0 00-5.58 1.5 4 4 0 001.53 5.5l5.78 3.3a13.74 13.74 0 000 6.47L114.53 71a4 4 0 00-1.53 5.5 4.08 4.08 0 003.52 2 4 4 0 002-.54l5.79-3.3a13.61 13.61 0 002.64 2 13.8 13.8 0 003 1.27v6.57a4.05 4.05 0 008.1 0v-6.61a14.22 14.22 0 005.68-3.23l5.79 3.3a4 4 0 002 .54 4.08 4.08 0 003.52-2 4 4 0 00-1.37-5.5zm-22.61-1.3a6 6 0 01-2.22-8.2 6.1 6.1 0 015.27-3 6.16 6.16 0 013 .8 6 6 0 012.22 8.2 6.12 6.12 0 01-8.27 2.2z",
    stroke: "#86c3db",
    strokeMiterlimit: 10,
    fill: "url(#snowy_svg__d)"
  })))), _Use || (_Use = /*#__PURE__*/React.createElement(Use, {
    width: 350,
    height: 222,
    transform: "translate(81 145)",
    xlinkHref: "#snowy_svg__e"
  })), _Use2 || (_Use2 = /*#__PURE__*/React.createElement(Use, {
    width: 156.2,
    height: 139,
    transform: "translate(177.9 337.5)",
    xlinkHref: "#snowy_svg__f"
  })));
}
export default SvgSnowy;